const COOKIES = [
  ["Essential cookies", "Required for the website to function (navigation, security, load balancing)."],
  ["Authentication cookies", "Keep signed-in admin/portal sessions active securely (httpOnly session cookies)."],
  ["Preference cookies", "Remember choices such as your selected display currency (stored locally in your browser)."],
  ["Analytics cookies", "Help us understand aggregate usage (page views, estimate clicks) to improve the service."],
  ["Security cookies", "Support fraud prevention and protection of forms and checkout."],
];

export default function CookiePolicy() {
  return (
    <div className="pt-32 lg:pt-40 pb-24" data-testid="cookie-policy-page">
      <div className="container-x max-w-3xl">
        <p className="section-label">LEGAL</p>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-black tracking-tight text-white">COOKIE POLICY</h1>
        <p className="mt-6 text-sm text-slate-400 leading-relaxed">
          Built2Last.live uses a small set of cookies and browser storage. Your currency preference is stored locally on
          your device and never transmitted as tracking data.
        </p>
        <div className="mt-10 space-y-6">
          {COOKIES.map(([t, b]) => (
            <div key={t} className="rounded-xl border border-white/10 bg-navy-800 p-6">
              <h2 className="font-heading font-bold text-white">{t}</h2>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-slate-400 leading-relaxed">
          You can control or delete cookies through your browser settings. Blocking essential or authentication cookies
          may prevent sign-in and checkout from working correctly.
        </p>
      </div>
    </div>
  );
}
